import api from './api';

class ProductService {
    // Get products for customer catalog
    async getCustomerProducts(filters = {}, limit = 20, offset = 0) {
        try {
            const params = new URLSearchParams({
                limit: limit.toString(),
                offset: offset.toString(),
                ...Object.fromEntries(
                    Object.entries(filters).filter(([_, value]) => value !== null && value !== undefined && value !== '')
                )
            });

            const response = await api.get(`/products/customer?${params}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get single product details
    async getProductDetails(productCode) {
        try {
            const response = await api.get(`/products/${productCode}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Check product availability
    async checkAvailability(productCode, size = null) {
        try {
            const params = size ? `?size=${encodeURIComponent(size)}` : '';
            const response = await api.get(`/products/${productCode}/availability${params}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get product types for filtering
    async getProductTypes() {
        try {
            const response = await api.get('/products/meta/types');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Get available colors for filtering
    async getAvailableColors() {
        try {
            const response = await api.get('/products/meta/colors');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Admin: Get all products (uses customer endpoint with no filters)
    async getAdminProducts(filters = {}, limit = 100, offset = 0) {
        try {
            const params = new URLSearchParams({
                limit: limit.toString(),
                offset: offset.toString(),
                ...Object.fromEntries(
                    Object.entries(filters).filter(([_, value]) => value !== null && value !== undefined && value !== '')
                )
            });

            const response = await api.get(`/products/customer?${params}`);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Admin: Update a product tag
    async updateProduct(productCode, data = {}) {
        try {
            const response = await api.patch(`/products/${encodeURIComponent(productCode)}/tags`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }

    // Admin: Get product statistics
    async getProductStats() {
        try {
            const response = await api.get('/products/meta/stats');
            return response.data;
        } catch (error) {
            throw error.response?.data || { success: false, message: 'Network error' };
        }
    }
}

export default new ProductService();
